"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderedList = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../../Theme/Theme.spacing");

var _Theme2 = require("../../Theme/Theme.variables");

var _styledSystem = require("styled-system");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          list-style-position: outside;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          list-style: none;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  margin-block-start: 0;\n  margin-block-end: 0;\n  margin-inline-start: 0;\n  margin-inline-end: 0;\n  padding-inline-start: 0;\n\n  font-family: ", ";\n  font-size: ", "px;\n  letter-spacing: ", ";\n  line-height: ", ";\n\n  /* color */\n  ", ";\n\n  ", ";\n\n  margin: 0 0 0\n    ", ";\n\n  li {\n    padding-left: 0px;\n    margin-left: 0;\n    margin-bottom: ", "px;\n    & > ol {\n      margin-top: ", "px;\n    }\n  }\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledList = _styledComponents.default.ol(_templateObject(), function (props) {
  return (0, _Theme2.variables)(props).fontBody;
}, function (props) {
  return props.small ? (0, _Theme2.variables)(props).fontSizeSm : (0, _Theme2.variables)(props).fontSizeBase;
}, function (props) {
  return props.small ? (0, _Theme2.variables)(props).letterSpacing.body[2] : (0, _Theme2.variables)(props).letterSpacing.body[1];
}, function (props) {
  return (0, _Theme2.variables)(props).fontBaseLineHeight;
}, function (props) {
  return props.textColor && (0, _styledComponents.css)(_templateObject2(), (0, _Theme2.variables)(props)[props.textColor]);
}, function (props) {
  return props.unstyled ? (0, _styledComponents.css)(_templateObject3()) : (0, _styledComponents.css)(_templateObject4());
}, function (props) {
  return props.offsetLeft || props.unstyled ? 0 : _Theme2.space[4] + 'px';
}, function (props) {
  return _Theme2.space[props.listSpace];
}, function (props) {
  return _Theme2.space[props.listSpace];
}, _styledSystem.space);

var OrderedList = function OrderedList(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react.default.createElement(StyledList, props, " ", children, " ");
};

exports.OrderedList = OrderedList;
OrderedList.displayName = 'OrderedList'; // Prop Types

OrderedList.propTypes = {
  unstyled: _propTypes.default.bool,
  offsetLeft: _propTypes.default.bool,
  listSpace: _propTypes.default.number
};
OrderedList.defaultProps = {
  unstyled: false,
  offsetLeft: false,
  listSpace: 2
};